import { FC, Fragment, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { Helmet } from 'react-helmet-async';
import PageTitleWrapper from '../../../components/PageTitleWrapper';
import AllSitesLedgerHeader from './PageHeader';
import PageContainerWrapper from '../../../components/PageContainerWrapper';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography, Paper, Tooltip, Link, TableContainer, useTheme } from '@mui/material';
import { currencyFormatter } from '../../../utils';
import { tableStyles } from '../Reports';


export interface AllSitesLedgerProps {}

export const AllSitesLedger: FC<AllSitesLedgerProps> = ({}) => {
  const classes = tableStyles();
  const theme = useTheme();
  const [checked, setChecked] = useState(true);
  const { data: siteReportRows } = useAppSelector(
    (state) => state.allSitesLedgerState
  );

  let lastSiteNo = '';
  let count = 0;
  return (
    <>
      <Helmet>
        <title>Billing Summary</title>
      </Helmet>
      <PageTitleWrapper>
        <AllSitesLedgerHeader onChecked={setChecked} />
      </PageTitleWrapper>
      <PageContainerWrapper>
        <TableContainer sx={{ maxHeight: 'calc(100vh - 200px)' }}>
          <Table aria-label="billing summary" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell 
                  width={20}
                  sx={{ 
                    backgroundColor: theme.palette.primary.main,
                    borderRight: '0.5px solid #ccc',
                    borderLeft: '0.5px solid #ccc',
                    fontWeight: 600,
                    color: theme.palette.primary.contrastText
                  }}
                >
                  S.N.
                </TableCell>
                <TableCell 
                  sx={{ 
                    backgroundColor: theme.palette.primary.main,
                    borderRight: '0.5px solid #ccc',
                    fontWeight: 600,
                    color: theme.palette.primary.contrastText,
                    maxWidth: 200
                  }}
                >
                  Party Name
                </TableCell>
                <TableCell 
                  sx={{ 
                    backgroundColor: theme.palette.primary.main,
                    borderRight: '0.5px solid #ccc',
                    fontWeight: 600,
                    color: theme.palette.primary.contrastText,
                    maxWidth: 200
                  }}
                >
                  Site
                </TableCell>
                <TableCell 
                  sx={{ 
                    backgroundColor: theme.palette.primary.main,
                    borderRight: '0.5px solid #ccc',
                    fontWeight: 600,
                    color: theme.palette.primary.contrastText
                  }}
                >
                  Site ID
                </TableCell>
                <TableCell 
                  sx={{ 
                    backgroundColor: theme.palette.primary.main,
                    borderRight: '0.5px solid #ccc',
                    fontWeight: 600,
                    color: theme.palette.primary.contrastText
                  }}
                >
                  Month
                </TableCell>
                <TableCell 
                  sx={{ 
                    backgroundColor: theme.palette.primary.main,
                    fontWeight: 600,
                    color: theme.palette.primary.contrastText
                  }}
                >
                  Billing
                </TableCell>
              </TableRow>
            </TableHead>
          <TableBody>
            {siteReportRows &&
              siteReportRows.map((bill, index) => {
                const isNewGroup = bill.monthIndex != 100 && bill.siteNo !== lastSiteNo;
                const isNotSum = !(bill.monthIndex == 100 || bill.monthIndex == 1000)
                if(isNotSum) {
                  lastSiteNo = bill.siteNo;
                }

                return (
                  <Fragment key={index}>
                    {/* {isNewGroup && (
                      // Insert a green blank row when siteNo changes
                      <TableRow sx={{backgroundColor:'#efeff0'}}>
                        <TableCell colSpan={6}></TableCell>
                      </TableRow>
                    )} */}
                    {(checked || isNotSum) && (
                    <TableRow>
                      <TableCell >{ isNotSum? ++count : ''}</TableCell> {/* Increment serial number */}
                     
                      <TableCell sx={{maxWidth:200}} colSpan={isNotSum ? 0 : 4} className={classes.tableCell}><Typography variant={isNotSum ? 'body1' : 'h5'}>{bill.party}</Typography></TableCell>
                      {isNotSum && (<>
                        <TableCell sx={{maxWidth:200}} className={classes.tableCell}>{bill.siteAddress}</TableCell>

                          <TableCell className={classes.tableCell}>
                            <Tooltip arrow title="Go to site details">
                              <Link
                               color={'#0000ff'}
                                underline="always"
                                href={`/slips/view-slips/${bill.siteNo}/${bill.partyId}?tab_index=6`}
                              >
                                {isNotSum ? bill.siteNo : ''}
                              </Link>
                            </Tooltip>


                          </TableCell>
                      <TableCell className={classes.tableCell}>{bill.month}</TableCell>
                      </>)}
                      <TableCell className={classes.tableCell}><Typography variant={isNotSum ? 'body1' : 'h5'}>{currencyFormatter.format(bill.invoiceSum)}</Typography></TableCell>
                     
                      </TableRow>
                    )}
                  </Fragment>
                );
              })}
          </TableBody>
        </Table>
        </TableContainer>
      </PageContainerWrapper>
    </>
  );
};

export default AllSitesLedger;
